<template>
  <div :class="['image-card', fixedHeight && 'fixed-height']">
    <div :style="{ backgroundImage: `url(${src})` }" class="img" />
    <span v-if="tag" class="tag text7">{{ formattedTag }}</span>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
.image-card {
  position: relative;
  width: rem(100%);
  border-width: 0;
  border-radius: rem(10px);
  overflow: hidden;
  @include setColor(--color-background1, background-color);
  box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.065);
  min-height: rem(266px);

  .img {
    width: 100%;
    height: rem(200px);
    background-position: center;
    background-size: cover;
    transform: scale(1);
    transition: 1000ms transform ease;
  }

  &:hover {
    .img {
      transform: scale(1.05);
    }
  }

  .tag {
    position: absolute;
    top: 10px;
    left: 10px;
    margin-right: rem(10px);
    padding: rem(5px 12px);
    border-radius: rem(15px);
    min-width: rem(120px);
    text-align: center;
    @include setColor(--color-cta, background-color);
    @include setColor(--color-text-negative, color);
  }

  .content {
    padding: rem(10px);
    position: relative;
    @include setColor(--color-background1, background-color);
  }

  @include respond-min("medium") {
    &.fixed-height {
      min-height: 0;

      .img {
        position: absolute;
        height: calc(100% - 50px);
        top: 0;
        width: 100%;
      }

      .content {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        min-height: rem(50px);
        height: auto;
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    src: {
      type: String,
      default: null,
    },
    fixedHeight: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: null,
    },
  },

  computed: {
    formattedTag() {
      return `# ${this.tag ? this.tag.toUpperCase() : this.tag}`;
    },
  },
};
</script>
